import { useState, useEffect } from 'react';

export const useSessionTimer = (sessionActive) => {
  const [sessionDuration, setSessionDuration] = useState(0);

  useEffect(() => {
    if (!sessionActive) return;

    const interval = setInterval(() => {
      setSessionDuration((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [sessionActive]);

  return sessionDuration;
};

export const useConnectionQuality = () => {
  const [connectionQuality, setConnectionQuality] = useState('excellent');

  useEffect(() => {
    const qualities = ['excellent', 'good', 'fair', 'poor'];
    const interval = setInterval(() => {
      const randomQuality = qualities?.[Math.floor(Math.random() * qualities?.length)];
      setConnectionQuality(randomQuality);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return connectionQuality;
};